import { Link } from "react-router-dom";
import React from "react";
export default function Thankyou() {
    return (
        <>
            <section className="thankyou-area">
                <img src="/assets/images/thankyou-banner.webp" className="thankyou-bannerimg img-responsive" alt="thank-you" />
                <div className="thankyou-textbox">
                    <div className="thankyou-envalop">
                        <img src="/assets/images/envalop.webp" alt="envalop" />
                    </div>
                    <h1 className="heading">thank You!</h1>
                    <p>We’ve received your details successfully. Our team will connect with you shortly to assist with your requirements.</p>
                    <div className="btn-sec">
                        <Link to={"/"} className="responsive-btn default-btn" >
                            <span>go to homepage</span>
                        </Link>
                    </div>
                </div>
            </section>
        </>
    )
}